import * as WorkOrderAction from './constants';

const WorkOrders = {};

const defaultParams = {
  searchKey: '',
  skip: 0,
  take: 10,
  sort: { field: 'refNo', order: 'descending' },
  status: '',
  totalRecord: 0,
  totalPage: 0,
  rfswoAssignedModeOrWOType:'',
  appliedFilterStatus:'',
  averageAge: 0
};

const WorkOrderState = {
  WorkOrders: WorkOrders,
  WorkOrderProfile: null,
  WorkOrdersList: {
    params: { ...defaultParams }
  },
  WorkOrderAttachments: [],
  IsRedirectToEdit: {
    isRedirect: false,
    refNo: null
  },
  Credentials: null,
  ManagePurchaseOrders: {
    items: [],
    params: defaultParams
  },
  PurchaseOrderProfile: {},
  ManageBackCharges: {
    items: [],
    params: {
      searchKey: '',
      skip: 0,
      take: 50
    }
  },
  BackChargeProfile: {},
  WorkOrderHistories: [],
  checkHomeownerWO: [],
  SavedFilterList: [],
  SavedFilterValueProfile: [],
  SelectedFilterName: null,
  ContactInformationList: [],
  RFSPrioritizedInformation: [],
  WODefaultConfig: '',
};

export default function WorkOrderStore(state = WorkOrderState, action) {
  switch (action.type) {
    case WorkOrderAction.GET_WORK_ORDER_BY_RFSID_SUCCESS:
      return processGetByRFSIDSuccess(state, action);
    case WorkOrderAction.GET_WORK_ORDER_DETAIL_SUCCESS:
      var workOrderProfile = {
        ...action.data,
        workOrder: {
          woInformation: action.data.workOrder
        },
        WorkOrderCommentList: []
      };
      if (action.data.requestDetail) {
        workOrderProfile['requestDetail'] = action.data.requestDetail;
      }
      return {
        ...state,
        WorkOrderProfile: workOrderProfile,
        WorkOrderAttachments: action.data.workOrder.attachments
          ? action.data.workOrder.attachments
          : []
      };
    case WorkOrderAction.RESOLVE_SUBCONTRACTOR_WORK_ORDER_SUCCESS:
      return {
        ...state,
        WorkOrderProfile: {
          ...state.WorkOrderProfile,
          workOrder: {
            woInformation: action.data.workOrder
          }
        }
      };
    case WorkOrderAction.PENDING_SUBCONTRACTOR_OPEN_WORK_ORDER_SUCCESS:
      return {
        ...state,
        WorkOrderProfile: {
          ...state.WorkOrderProfile,
          workOrder: {
            woInformation: action.data.workOrder
          }
        }
      };
    case WorkOrderAction.EDIT_HOMEOWNER_WORK_ORDER_SUCCESS:
    case WorkOrderAction.UPLOAD_SIGNATURE_CHECK_STATUS:
      return {
        ...state,
        UploadSuccess: true
      };
    case WorkOrderAction.UPLOAD_SIGNATURE_RESET_STATUS:
      return {
        ...state,
        UploadSuccess: false
      };
    case WorkOrderAction.UPDATE_WORK_ORDER_SUCCESS:
      var workOrder = {
        ...state.WorkOrderProfile,
        workOrder: {
          woInformation: action.data
        }
      };
      return {
        ...state,
        WorkOrderProfile: workOrder
      };
    case WorkOrderAction.GET_WORK_ORDER_BY_RFSID: {
      return {
        ...state,
        WorkOrderCommentList: []
      };
    }
    case WorkOrderAction.CREATE_WORK_ORDER_SUCCESS:
      return {
        ...state,
        WorkOrderProfile: {
          workOrder: {
            woInformation: action.data.workOrderProfile
          }
        },
        IsRedirectToEdit: action.data
      };
    case WorkOrderAction.SET_IS_REDIRECT_WORK_ORDER_FALSE:
      var isRedirect = {
        isRedirect: false,
        refNo: null
      };
      return {
        ...state,
        IsRedirectToEdit: isRedirect
      };
    case WorkOrderAction.SET_IS_UPLOADED:
      return {
        ...state,
        IsUploaded: false
      };
    case WorkOrderAction.OPEN_AN_AWAITING_WORK_ORDER_SUCCESS:
      var newWorkOrderProfile = {
        ...state.WorkOrderProfile,
        workOrder: {
          woInformation: action.data
        }
      };
      return {
        ...state,
        WorkOrderProfile: newWorkOrderProfile,
        IsRedirectToEdit: {...action.data, isRedirect: action.IsRedirectToEdit}
      };
    case WorkOrderAction.GET_WORK_ORDER_COMMENTS_SUCCESS:
      return {
        ...state,
        WorkOrderCommentList: action.data
      };
    case WorkOrderAction.GET_WORK_ORDER_PRIVATE_NOTES_SUCCESS:
      return {
        ...state,
        WorkOrderPrivateNotesList: action.data
      };
    case WorkOrderAction.UPDATE_CAPTION_ATTACHMENT_WORK_ORDER_SUCCESS:
      var { caption, id } = action.data;
      var attachmentsList = [...state.WorkOrderAttachments];
      attachmentsList.map(element => {
        if (element.id === id) {
          element.caption = caption;
        }
      });
      return {
        ...state,
        WorkOrderAttachments: attachmentsList
      };
    case WorkOrderAction.SETUP_AWS_S3_SUCCESS:
      return {
        ...state,
        Credentials: action.data
      };
    case WorkOrderAction.UPLOAD_TO_SERVER_SUCCESS:
      var newAttachments = [...state.WorkOrderAttachments, action.data];
      return {
        ...state,
        WorkOrderAttachments: newAttachments
      };
    case WorkOrderAction.RESET_ATTACHMENTS:
      return {
        ...state,
        WorkOrderAttachments: []
      };
    case WorkOrderAction.SEARCH_SUBCONTRACTOR_WORK_ORDER_SUCCESS:
    case WorkOrderAction.SEARCH_WORK_ORDER_LIST_SUCCESS:
      return processSearchWorkOrdersList(state, action);
    case WorkOrderAction.RESET_WORK_ORDER_PROFILE:
      return {
        ...state,
        WorkOrderProfile: null
      };

    case WorkOrderAction.RESET_FILTER_NAME_PROFILE:
      return {
        ...state,
        SelectedFilterName: null
      };
    // case WorkOrderAction.SEARCH_WORK_ORDER_LIST_ASYNC:
    case WorkOrderAction.SEARCH_WORK_ORDER_LIST_FAIL:
      return {
        ...state,
        WorkOrdersList: {
          params: defaultParams
        }
      };
    case WorkOrderAction.GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_SUCCESS:
      return {
        ...state,
        ManageBackCharges: {
          items: action.data.items
        }
      };
    case WorkOrderAction.GET_BACK_CHARGE_LIST_OF_PURCHASE_ORDER_FAIL:
      return {
        ...state,
        ManageBackCharges: {
          items: [],
          params: {
            searchKey: '',
            skip: 0,
            take: 50
          }
        }
      };

    case WorkOrderAction.GET_BACK_CHARGE_DETAIL_ASYNC:
      return {
        ...state,
        BackChargeProfile: []
      };
    case WorkOrderAction.GET_BACK_CHARGE_DETAIL_SUCCESS:
    case WorkOrderAction.EDIT_BACK_CHARGE_SUCCESS:
      return {
        ...state,
        BackChargeProfile: action.data
      };
    case WorkOrderAction.GET_WORK_ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        WorkOrderHistories: action.data
      };
    case WorkOrderAction.RESET_WORK_ORDER_LIST:
      return {
        ...state,
        WorkOrdersList: {
          params: { ...defaultParams }
        }
      };
    case WorkOrderAction.CHECK_HOMEOWNER_SIGNATURE_WO_SUCCESS:
      return {
        ...state,
        checkHomeownerWO: action.data
      };
    case WorkOrderAction.GET_SAVED_FILTERED_WO_LIST_SUCCESS:
      return {
        ...state,
        SavedFilterList: action.data
      };
    case WorkOrderAction.GET_SAVED_FILTERED_WO_VALUE_SUCCESS:
      return {
        ...state,
        SavedFilterValueProfile: action.data,
        SelectedFilterName: action.data.name
      };
    case WorkOrderAction.GET_CONTACT_INFO_SUCCESS:
      return {
        ...state,
        ContactInformationList: action.data
      };
    case WorkOrderAction.GET_LIST_CONTACT_PRIORITIZED_SUCCESS:
      return {
        ...state,
        RFSPrioritizedInformation: action.data
      };
    case WorkOrderAction.GET_LAST_RESOLVED_WORK_ORDER_SUCCESS:
        return {
          ...state,
          LastResolvedByDetails: action.data
        };
    default:
      return state;
  }
}

const processGetByRFSIDSuccess = (state, action) => {
  return {
    ...state,
    WorkOrders: action.data.data
  };
};

const processSearchWorkOrdersList = (state, action) => {
  const {items, totalRecord, totalPage, rfswoAssignedModeOrWOType, appliedFilterStatus, averageAge} = action.data.data;
  const {sortOrder,sortField, skip, take, SelectedFilterName, WODefaultConfig } = action.data.params;
  return {
    ...state,
    WorkOrdersList: {
      items: items,
      params: {
        // ...action.data.params,
        skip: skip + 1,
        take: take,
        sort: {
          field: sortField,
          order: sortOrder
        },
        totalPage: totalPage,
        totalRecord: totalRecord,
        rfswoAssignedModeOrWOType: rfswoAssignedModeOrWOType,
        appliedFilterStatus: appliedFilterStatus,
        WODefaultConfig: WODefaultConfig,
        averageAge: averageAge

      }
    },
    SelectedFilterName: SelectedFilterName || null,
    WODefaultConfig: action.data.params
  };
};



// WEBPACK FOOTER //
// ./src/Work-Orders/reducers.js